
import React from 'react';

const InterviewTypeOption = ({ type, isSelected, onSelect }) => {
  return (
    <div
      onClick={onSelect}
      style={{
        background: isSelected ? 'rgba(72, 187, 120, 0.1)' : '#f8fafc',
        border: `2px solid ${isSelected ? '#48bb78' : '#e2e8f0'}`,
        borderRadius: '12px',
        padding: '20px',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
      }}
    >
      <div style={{ fontSize: '2rem', marginBottom: '10px' }}>
        {type.id === 'call' ? '📞' : '💬'}
      </div>
      <div style={{ fontWeight: 600, color: '#2d3748', marginBottom: '5px' }}>
        {type.label}
      </div>
      <div style={{ fontSize: '0.85rem', color: '#718096' }}>
        {type.description}
      </div>
    </div>
  );
};

export default InterviewTypeOption;
